import React from "react";
import DeselectableRadioGroup from "../../../../blocks/FormItems/DeselectableRadioGroup";
import { onceTwiceOptions } from "../../Options/physioOptions";

const RecreationSchedule = ({ form }) => {
  return (
    <>
      <DeselectableRadioGroup
        name={"recreation_schedule"}
        label={"Recreation Schedule"}
        options={onceTwiceOptions}
        form={form}
      />
    </>
  );
};

export default RecreationSchedule;
